module.exports = __webpack_public_path__ + "static/media/full-text.472439ae.png";